import { StaffManagementActions } from './StaffManagementActions';

export class StaffManagementEvents {
  category = 'Staff Management';
  action = new StaffManagementActions();
}

